module.exports = __webpack_public_path__ + "static/media/warnig-invoices.a4f948da.svg";